<template>
  <div class="card">
    <template v-if="list.length==0">
      <div class="no-data">
        <img src="@images/none.png" />
        <div>暂无数据</div>
      </div>
    </template>
    <template v-else>
      <div class="list">
        <div class="item" v-for="item in list" @click="$router.push({name:'rulesDetail',params:{id:item.id}})">
          <!-- <img :src="item.imagePath" />
          <div style="padding:20px 10px;text-align:center">
            <div class="title">{{item.title}}</div>
          </div> -->
          <span class="title">{{item.title}}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    getList() {
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      }
      this.$api.ruleList(params).then(res => {
        // console.log(res)
        this.total = res.data.total
        this.list = res.data
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// .list {
//   display: flex;
//   justify-content: flex-start;
//   margin: 10px 0;
//   flex-wrap: wrap;
//   .item {
//     width: 400px;
//     margin: 10px;
//     position: relative;
//     background: #fff;
//     box-shadow: 0px 0px 8px 0px rgba(224, 229, 237, 1);
//     flex: none;
//     cursor: pointer;
//     .title {
//       font-size: 18px;
//       width: 100%;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       white-space: nowrap;
//     }
//     img {
//       width: 100%;
//       height: 250px;
//     }
//   }
// }
.list {
  margin: 20px;
  .item {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #dadada;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      margin-right: 10px;
    }
    .title {
      width: calc(100% - 40px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
